import React from 'react';
import { injectIntl } from 'react-intl';
import { customerLogo } from '../../config';
import i18n from "../../main/i18n";

const logo = props => {
  const msg = i18n.getMsg(props.intl);
  return (
    <div className="row">
      <div className="col-md-6">
        <div className="logo">
          <img src={customerLogo} alt={msg('imgAlt.logo')} className="img-responsive center-block"/>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(logo);
